"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBio2X = function IconBio2X(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M23.82 5a3.53 3.53 0 0 1 3.53 3.53c0 .94-.392 1.688-1.11 2.315l2.034.813q.076-.259.123-.53l.03-.209.107-.879h8.245a3 3 0 0 1 1.942.71l.157.144 6.886 6.718-4.227 4.105-1.394-1.434 2.753-2.675-5.415-5.283a1 1 0 0 0-.571-.277l-.13-.008-6.537-.001-.011.046a6.461 6.461 0 0 1-12.392.243l-.084-.289-6.537.001a1 1 0 0 0-.602.2l-.099.086L5.1 17.61l3.892 3.811 1.289-1.287c.814-.842 2.59-.666 2.712.713L13 21v20h22V27h2v16H11V22.244l-1.993 1.993-6.768-6.628 6.882-6.714a3 3 0 0 1 1.886-.848l.213-.007h8.246l.107.88q.046.377.151.732l2.796-1.111q.177-.07.36-.124l-.002-.003c1.625-.61 2.472-1.267 2.472-1.884a1.53 1.53 0 0 0-3.054-.14l-.006.14h-2A3.53 3.53 0 0 1 23.82 5m-3.096 8.407A4.45 4.45 0 0 0 24 14.84a4.45 4.45 0 0 0 3.272-1.428l-2.532-1.013a2 2 0 0 0-1.3-.062l-.18.062zm12.33 4.876 1.413 1.414L23.157 31H26v2h-4.843l-4.12 4.117-1.414-1.414L25 26.33V21h2v3.332zM29.84 27.2a3 3 0 0 1 2.44 1.16 3.14 3.14 0 0 1-4.88 0 3 3 0 0 1 2.44-1.16m7.93-4.12a3 3 0 0 0-2.44-1.16 3 3 0 0 0-2.44 1.16 3.14 3.14 0 0 0 4.88 0m-16.18 3.84a3 3 0 0 1-1.16 2.44 3.14 3.14 0 0 1 0-4.88 3 3 0 0 1 1.16 2.44",
    clipRule: "evenodd"
  })));
};

export { IconBio2X, IconBio2X as default };
